module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4R06TgXSaup6yKBLl6eRZo-3c5527cd6d1b59fcd8648d224945507c.jpg";